import { useState, useEffect } from "react";

type QueryParamType = string | undefined;

export function useQueryParam(
  key: string,
  defaultValue: QueryParamType,
  supportedValues?: string[]
): [QueryParamType, (val: QueryParamType) => void] {
  const readValue = (): QueryParamType => {
    const searchParams = new URLSearchParams(location.search);
    const item = searchParams.get(key);
    if (supportedValues && item && !supportedValues.includes(item)) return defaultValue;
    return item ?? defaultValue;
  };

  const [storedValue, setStoredValue] = useState(readValue);

  useEffect(() => {
    const url = new URL(window.location.href);

    if (storedValue) url.searchParams.set(key, storedValue);
    else url.searchParams.delete(key);

    window.history.pushState({}, "", url);
  }, [key, storedValue]);

  return [storedValue, setStoredValue];
}
